import { RiServerFill } from "react-icons/ri";
import {
  COSTUM,
  DATE,
  SELECT,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { HISOBOT } from "../../Component/Sidebar/PageTypes";
import PrintBtn from "./components/PrintBtn";
import Refresh from "./components/Refresh";
const YukBeruvchilarQoldigi = {
  title: "Юк берувчилар қолдиги",
  path: "/hisobot/yuk-beruvchilar-qoldigi",
  icon: <RiServerFill></RiServerFill>,
  type: HISOBOT,
  allData: [{ value: "yuk_beruvchi_id", prop: "yuk_beruvchilar", get: "fio" }],
  hisobotActions: [
    {
      grid: "1fr 3fr 1fr",
      inputs: [
        {
          label: "Сана",
          name: "sana3",
          type: DATE,
        },
        {
          label: "Юк берувчи",
          name: "yuk_beruvchi_id",
          type: SELECT,
          allData: {
            type: "yuk_beruvchilar",
            key: "Id",
            text: "fio",
          },
        },
        {
          type: COSTUM,
          component: (
            <div
              style={{ display: "flex", gridGap: "10px", alignItems: "center" }}
            >
              <Refresh text="Янгилаш"></Refresh>
              <PrintBtn></PrintBtn>
            </div>
          ),
        },
      ],
    },
  ],
};
export default YukBeruvchilarQoldigi;
